import { createAction } from '@reduxjs/toolkit';

export const setUser = createAction<string>('SET_USER');
export const setInviteData = createAction<{ advisorName: string; firmName: string } | undefined>('SET_INVITE_DATA');
